import { FetchResult } from '@apollo/client';
import { zodResolver } from '@hookform/resolvers/zod';
import { FormErrorMessage } from '@pendwa/common-browser/components/Form/ErrorMessage/index.js';
import { FormInputText } from '@pendwa/common-browser/components/Form/InputText/index.js';
import { FormSubmitButton } from '@pendwa/common-browser/components/Form/SubmitButton/index.js';
import { LayoutSpacer } from '@pendwa/common-browser/components/LayoutSpacer/index.js';
import { LayoutSpacerSmall } from '@pendwa/common-browser/components/LayoutSpacerSmall/index.js';
import { extractGraphQLErrorMessage } from '@pendwa/common-browser/core/apollo/utils.js';
import { auth_codeSchema } from '@pendwa/db/generated/zod/index.js';
import React from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { HooksLoginAuthCodeMutation } from '../../../generated/graphql.js';
import { useLoginAuthCodeGraphql } from '../../../hooks/user/loginAuthCode.js';

const schema = z
  .object({
    code: auth_codeSchema.shape.code,
  })
  .required();

export const LoginAuthCode: React.FC<{
  handleSuccess: (result: FetchResult<HooksLoginAuthCodeMutation>) => void;
}> = (props) => {
  const { result: mutation_result, doAction } = useLoginAuthCodeGraphql();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<z.infer<typeof schema>>({
    resolver: zodResolver(schema),
  });

  return (
    <LayoutSpacer>
      {mutation_result.error && (
        <FormErrorMessage
          message={extractGraphQLErrorMessage(mutation_result.error) ?? 'Something went wrong.'}
        />
      )}

      <form
        onSubmit={handleSubmit(async (data) => {
          const action_result = await doAction({
            variables: {
              code: data.code,
            },
          });

          if (!action_result.errors && action_result.data?.loginAuthCode?.data?.status) {
            await props.handleSuccess(action_result);
          }
        })}
      >
        <LayoutSpacerSmall>
          <FormInputText
            label={'Code'}
            description={'Enter the code you see on your device.'}
            input_type={'text'}
            input_name={'code'}
            register={register}
            error={errors.code?.message}
          />

          <FormSubmitButton label={'Link Device'} loading={mutation_result.loading} />
        </LayoutSpacerSmall>
      </form>
    </LayoutSpacer>
  );
};
